import { useQuery } from "@tanstack/react-query";
import { useHotel } from "@/hooks/useHotel";
import { partnerSettingsService } from "@/services/partner-settings-service";

/** QR entries and service orders of the current hotel (Rapid dashboard, DV-83). */
export const useDashboardQrMetrics = (enabled: boolean) => {
  const { hotelId } = useHotel();

  const query = useQuery({
    queryKey: ["dashboard", "qrMetrics", hotelId] as const,
    queryFn: () =>
      partnerSettingsService.getPartnerQrMetrics(hotelId as string),
    enabled: enabled && Boolean(hotelId),
    staleTime: 30_000,
  });

  return {
    metrics: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
  };
};
